import { render, staticRenderFns } from "./Upcomingdetail.vue?vue&type=template&id=54e6ec16&"
import script from "./Upcomingdetail.vue?vue&type=script&lang=js&"
export * from "./Upcomingdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports